module.exports = __webpack_public_path__ + "static/media/weather-forecaster-cropped.f3d0b937.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/images/weather-forecaster-cropped.PNG
// module id = 42
// module chunks = 0